import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorChatState = (state: RootState) => state.chat;

export const selectorChat = createSelector(
  selectorChatState,
  (chatState) => chatState
);
